import styled from "styled-components";

import LineBreak from "@/atoms/LineBreak";
import { LINKS } from "globalConfig";
import { LinkNext, colors } from "@literati/public-ui-shared-react";
import { OrderSummaryItem } from "lib/api/checkout";
import BookBucks from "@/atoms/Icon/book-bucks";
import { SUBSCRIPTION_PLAN_SLUGS } from "components/PlanSelection/planSelectionTypes";

const StyledVoucher = styled.div`
  background: ${colors.mintTint4};
  padding: 1.875rem;
  margin: 0 -1.875rem 0.75rem;
  display: flex;
  gap: 1.25rem;
  align-items: center;
`;

const IconContainer = styled.div`
  width: 4rem;
`;

interface CheckoutRewardVoucherProps {
  orderSummaryDetails: { [key: string]: OrderSummaryItem };
}

/**
 * This component is used to display details of the order's reward voucher
 * if it has one.
 *
 * @param {Object} props
 * @param {Object} props.orderSummaryDetails
 */
const CheckoutRewardVoucher: React.FC<CheckoutRewardVoucherProps> = ({
  orderSummaryDetails,
}) => {
  const { planSlug } = orderSummaryDetails.item || {};

  const {
    TBYB_ANNUAL_2023_06,
    TBYB_ANNUAL_INC_20,
    TBYB_ANNUAL_INC_20_CREDITS_60,
  } = SUBSCRIPTION_PLAN_SLUGS;

  if (planSlug == TBYB_ANNUAL_2023_06) {
    return (
      <VoucherDetails>
        <b>Your $120 credit has been added!</b>
        <p>
          When you purchase books from your box, the credit will be
          automatically applied.{" "}
          <LinkNext href={LINKS.contact} legacyBehavior={false}>
            Get in touch.
          </LinkNext>
        </p>
      </VoucherDetails>
    );
  }

  if (planSlug == TBYB_ANNUAL_INC_20) {
    return (
      <VoucherDetails>
        <b>Your $120 credit has been added!</b>
        <p>
          We&apos;ll automatically take $20 off your first 6 boxes when you
          decide to keep books.{" "}
          <LinkNext href={LINKS.contact} legacyBehavior={false}>
            Get in touch.
          </LinkNext>
        </p>
      </VoucherDetails>
    );
  }

  if (planSlug == TBYB_ANNUAL_INC_20_CREDITS_60) {
    return (
      <VoucherDetails>
        <b>Your $60 credit has been added!</b>
        <p>
          We&apos;ll automatically take $20 off your first 3 boxes when you
          decide to keep books.{" "}
        </p>
      </VoucherDetails>
    );
  }

  // if there isn't a reward voucher to display
  // then return a line break
  return <LineBreak />;
};

export default CheckoutRewardVoucher;

const VoucherDetails: React.FC = (props) => {
  const { children } = props;
  return (
    <StyledVoucher>
      <IconContainer>
        <BookBucks />
      </IconContainer>
      <div>{children}</div>
    </StyledVoucher>
  );
};
